'use client'

import { graphql } from '~/gql'
import { useGQLQuery } from '~/hooks/useGraphQL'

// 10 Minutes
const staleTime = 10 * 60 * 1000

const evaluationQuery = graphql(`
  query EvaluationVersionClient($id: ID!) {
    evaluation: evaluationVersion(id: $id) {
      id
      name
      slug
      modDate
      versionNumber
      collaborators {
        id
        avatar
        name
        email
        roles
        allowPermissions
        status
      }
      status {
        key
        value
      }
      evaluationVersions {
        id
        evaluationId
        versionNumber
      }
      workspace {
        id
      }
      owner {
        memberId
      }
    }
  }
`)

export const useEvaluationQuery = (id: string, enabled: boolean = true) =>
  useGQLQuery(evaluationQuery, { id }, { 
    staleTime, 
    enabled: enabled && !!id,
    refetchOnWindowFocus: false, // Disable refetch on window focus to prevent unnecessary requests
  })
